import { useEffect } from 'react'
import styles from './FlyerModal.module.css'

export function FlyerModal({ src, onClose }: { src: string; onClose: () => void }) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [onClose])

  return (
    <div className={styles.backdrop} role="dialog" aria-modal="true" aria-label="Event flyer" onClick={onClose}>
      <button type="button" className={styles.close} onClick={onClose} aria-label="Close">
        ×
      </button>
      <img src={src} alt="Event flyer, full size" className={styles.image} onClick={(e) => e.stopPropagation()} />
    </div>
  )
}
